import { render, staticRenderFns } from "./PageLayout.vue?vue&type=template&id=fe6373d6&scoped=true&"
import script from "./PageLayout.vue?vue&type=script&lang=js&"
export * from "./PageLayout.vue?vue&type=script&lang=js&"
import style0 from "./PageLayout.vue?vue&type=style&index=0&id=fe6373d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe6373d6",
  null
  
)

export default component.exports